import React from 'react';
import AppLayout from '../../layout/app.layout';
import ListAppsVersion from '../../components/content/apps-version-history.component';

const AppVersionHistoryView = () => {
  const pageTitle = 'App Version History';

  return (
    <AppLayout pageTitle={pageTitle}>
      <ListAppsVersion />
    </AppLayout>
  );
};

export default AppVersionHistoryView;
